
import { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaRegQuestionCircle } from "react-icons/fa";
import { AiOutlineAudit, AiOutlineAppstore } from "react-icons/ai";
import { GrTransaction, GrUserSettings } from "react-icons/gr";
import { FaUsers } from "react-icons/fa";
import { SlSettings } from "react-icons/sl";
import { HiOutlineDatabase } from "react-icons/hi";
import { TbReportAnalytics } from "react-icons/tb";
import { RiBuilding3Line } from "react-icons/ri";
import { useMediaQuery } from "react-responsive";
import { MdMenu } from "react-icons/md";
import Cookies from "js-cookie";
import { Link, NavLink, useLocation } from "react-router-dom";
import SubMenu from "./SubMenu";
import onehubLogo from "./onehubLogo.png"

const Sidebar = () => {
  let isTabletMid = useMediaQuery({ query: "(max-width: 768px)" });
  const [open, setOpen] = useState(isTabletMid ? false : true);
  const sidebarRef = useRef();
  const { pathname } = useLocation();
  const role = Cookies.get("userRole");

  const [selectedSubMenu, setSelectedSubMenu] = useState(null);
  const [isRetrieveTransactionDisabled, setIsRetrieveTransactionDisabled] =
    useState(true);

  const handleSubMenuClick = (subMenuName) => {
    setSelectedSubMenu(subMenuName);
  };

  useEffect(() => {
    if (isTabletMid) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isTabletMid]);

  useEffect(() => {
    isTabletMid && setOpen(false);
  }, [pathname]);

  const Nav_animation = {
    open: {
      width: "16rem",
      transition: {
        damping: 40,
      },
    },
    collapsed: {
      width: "4rem",
      transition: {
        damping: 40,
      },
    },
  };

  const subMenusList = [
    {
      name: "fund-transfer",
      icon: RiBuilding3Line,
      menus:
        role == 1 || role == 3
          ? ["transfers", "status", "rejected"]
          : ["approvals", "status", "rejected"],
    },
  ];

  const handleRetrieveTransactionClick = () => {
    setIsRetrieveTransactionDisabled(!isRetrieveTransactionDisabled);
  };

  return (
    <div className="side-pane relative opacity-100" style={{zIndex: 2}}>
      <div
        className={`flex ${open ? "w-64" : "w-16"}`}
        style={{ backgroundColor: "#17275C" }}
      >
        <div className="fixed h-screen text-white w-64 md:w-auto">
          <div
            onClick={() => setOpen(false)}
            className={`md:hidden fixed inset-0 max-h-screen z-[998] bg-black/50 ${
              open ? "block" : "hidden"
            } `}
          ></div>
          <motion.div
            ref={sidebarRef}
            variants={Nav_animation}
            initial={{ width: isTabletMid ? "4rem" : "16rem" }}
            animate={open ? "open" : "collapsed"}
            className="bg-dark-blue text-gray shadow-xl z-[999] max-w-[16rem] w-[16rem] overflow-hidden md:relative fixed h-screen"
          >
            <div className="relative flex items-center gap-2.5 font-medium py-3 border-slate-300 mx-3">
              <img
                className={`rounded-full mx-auto mb-4 border border-white bg-white mt-4 ${
                  open ? "w-20 h-20" : "w-20 h-10"
                }`}
                 src={onehubLogo}
                style={{ borderRadius: "50%" }}
              />
              <motion.div
                onClick={() => setOpen(!open)}
                animate={open ? { rotate: 0 } : { rotate: 180 }}
                transition={{ duration: 0.2 }}
                className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 cursor-pointer"
              >
                {open ? (
                  <IoIosArrowBack size={25} className="text-white" />
                ) : (
                  <IoIosArrowForward size={25} className="text-white" />
                )}
              </motion.div>
            </div>

            <div className="flex flex-col h-screen">
              <ul className="whitespace-pre px-2.5 text-[0.9rem] flex flex-col font-medium overflow-x-hidden scrollbar-thin scrollbar-track-white scrollbar-thumb-slate-100 md:h-[68%] h-[70%]">
                <li className="flex items-center mb-2">
                  <NavLink
                    to={"/home"}
                    className="link flex items-center justify-between w-full"
                  >
                    <div className="flex items-center">
                      <AiOutlineAppstore size={23} className="min-w-max" />
                      <span className="ml-6">Home</span>
                    </div>
                    <div className="flex items-center flex-row-reverse">
                      <IoIosArrowForward size={18} />
                    </div>
                  </NavLink>
                </li>
                {(open || isTabletMid) && (
                  <div className="py-3 border-slate-300">
                    {subMenusList?.map((menu) => (
                      <div key={menu.name} className="flex flex-col gap-2">
                        <SubMenu
                          data={menu}
                          onClick={() => handleSubMenuClick(menu.name)}
                          isSelected={selectedSubMenu === menu.name}
                        />
                      </div>
                    ))}
                  </div>
                )}
                <li className="flex items-center mb-3">
                  <div
                    className={`link flex items-center justify-between w-full ${
                      isRetrieveTransactionDisabled
                        ? "pointer-events-none opacity-50"
                        : ""
                    }`}
                    onClick={handleRetrieveTransactionClick}
                  >
                    <div className="flex items-center">
                      <GrTransaction size={23} className="min-w-max" />
                      <span className="ml-6">Retrieve Transaction</span>
                    </div>
                  </div>
                </li>
                <li className="flex items-center mb-3">
                  <NavLink
                    to={"/vendor-master"}
                    className="link flex items-center justify-between w-full"
                  >
                    <div className="flex items-center">
                      <FaUsers size={23} className="min-w-max" />
                      <span className="ml-6">Vendor Master</span>
                    </div>
                    <div className="flex items-center flex-row-reverse">
                      <IoIosArrowForward size={18} />
                    </div>
                  </NavLink>
                </li>
                <li className="flex items-center mb-2">
                  <NavLink
                    to={"/audit-log"}
                    className="link flex items-center justify-between w-full"
                  >
                    <div className="flex items-center">
                      <AiOutlineAudit size={23} className="min-w-max" />
                      <span className="ml-6">Audit Log</span>
                    </div>
                    <div className="flex items-center flex-row-reverse">
                      <IoIosArrowForward size={18} />
                    </div>
                  </NavLink>
                </li>
                <div>
                  <hr className="mt-10" />
                  <div className="flex border-slate-300 p-4 items-center justify-center">
                    <Link to="/settings">
                      <GrUserSettings
                        className={
                          "min-w-max text-white" +
                          (open ? " w-9 h-9" : " w-7 h-7")
                        }
                      />
                    </Link>
                  </div>
                  <div className="flex border-slate-300 p-4 items-center justify-center">
                    <FaRegQuestionCircle
                      className={
                        "min-w-max text-white" +
                        (open ? " w-9 h-9" : " w-7 h-7")
                      }
                    />
                  </div>
                </div>
              </ul>
            </div>
          </motion.div>
          <div className="m-3 md:hidden" onClick={() => setOpen(true)}>
            <MdMenu size={25} className="bg-dark-blue rounded-s-sm" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

//sidepane collapse transition
// import { useEffect, useState, useRef } from "react";
// import { motion } from "framer-motion";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import { FaRegQuestionCircle } from "react-icons/fa";
// import { AiOutlineAudit } from "react-icons/ai";
// import { GrTransaction } from "react-icons/gr";
// import { FaUsers } from "react-icons/fa";
// import { SlSettings } from "react-icons/sl";
// import { AiOutlineAppstore } from "react-icons/ai";
// import { GrUserSettings } from "react-icons/gr";
// import { BsPerson } from "react-icons/bs";
// import { HiOutlineDatabase } from "react-icons/hi";
// import { TbReportAnalytics } from "react-icons/tb";
// import { RiBuilding3Line } from "react-icons/ri";
// import { useMediaQuery } from "react-responsive";
// import { MdMenu } from "react-icons/md";
// import Cookies from "js-cookie";
// import { Link, NavLink, useLocation } from "react-router-dom";
// import SubMenu from "./SubMenu";

// const Sidebar = () => {
//   let isTabletMid = useMediaQuery({ query: "(max-width: 768px)" });
//   const [open, setOpen] = useState(isTabletMid ? false : true);
//   const sidebarRef = useRef();
//   const { pathname } = useLocation();
//   const role = Cookies.get("userRole");

//   const [selectedSubMenu, setSelectedSubMenu] = useState(null);
//   const [isRetrieveTransactionDisabled, setIsRetrieveTransactionDisabled] =
//     useState(true);

//   const handleSubMenuClick = (subMenuName) => {
//     setSelectedSubMenu(subMenuName);
//   };

//   useEffect(() => {
//     if (isTabletMid) {
//       setOpen(false);
//     } else {
//       setOpen(true);
//     }
//   }, [isTabletMid]);

//   useEffect(() => {
//     isTabletMid && setOpen(false);
//   }, [pathname]);

//   const Nav_animation = isTabletMid
//     ? {
//         open: {
//           x: 0,
//           width: "16rem",
//           transition: {
//             damping: 40,
//           },
//         },
//         closed: {
//           x: -250,
//           width: 0,
//           transition: {
//             damping: 40,
//             delay: 0.15,
//           },
//         },
//       }
//     : {
//         open: {
//           width: "16rem",
//           transition: {
//             damping: 40,
//           },
//         },
//         closed: {
//           width: "4rem",
//           transition: {
//             damping: 40,
//           },
//         },
//       };

//   const subMenusList = [
//     {
//       name: "fund-transfer",
//       icon: RiBuilding3Line,
//       menus:
//         role == 1 || role == 3
//           ? ["transfers", "status", "rejected"]
//           : ["approvals", "status", "rejected"],
//     },
//   ];

//   const handleRetrieveTransactionClick = () => {
//     setIsRetrieveTransactionDisabled(!isRetrieveTransactionDisabled);
//   };

//   return (
//     <div className="side-pane relative opacity-100">
//       <div
//         className={`flex ${open ? "w-64" : "w-16"}`}
//         style={{ backgroundColor: "#17275C" }}
//       >
//         <div className="fixed h-screen text-white w-64 md:w-auto">
//           <div
//             onClick={() => setOpen(false)}
//             className={`md:hidden fixed inset-0 max-h-screen z-[998] bg-black/50 ${
//               open ? "block" : "hidden"
//             } `}
//           ></div>
//           <motion.div
//             ref={sidebarRef}
//             variants={Nav_animation}
//             initial={{ x: isTabletMid ? -250 : 0 }}
//             animate={open ? "open" : "closed"}
//             className="bg-dark-blue text-gray shadow-xl z-[999] max-w-[16rem] w-[16rem] overflow-hidden md:relative fixed h-screen"
//           >
//             <div className="relative flex items-center gap-2.5 font-medium py-3 border-slate-300 mx-3">
//               <img
//                 className={`rounded-full mx-auto mb-4 border border-white bg-white mt-4 ${
//                   open === true ? "w-40 h-40" : "w-20 h-10"
//                 }`}
//                 style={{ borderRadius: "50%" }}
//               />
//               <motion.div
//                 onClick={() => setOpen(!open)}
//                 animate={open ? { rotate: 0 } : { rotate: 360 }}
//                 transition={{ duration: 0.2 }}
//                 className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 cursor-pointer"
//               >
//                 {open ? (
//                   <IoIosArrowBack size={25} className="text-white" />
//                 ) : (
//                   <IoIosArrowForward size={25} className="text-white" />
//                 )}
//               </motion.div>
//             </div>

//             <div className="flex flex-col h-screen">
//               <ul className="whitespace-pre px-2.5 text-[0.9rem] flex flex-col font-medium overflow-x-hidden scrollbar-thin scrollbar-track-white scrollbar-thumb-slate-100 md:h-[68%] h-[70%]">
//                 <li className="flex items-center mb-2">
//                   <NavLink
//                     to={"/home"}
//                     className="link flex items-center justify-between w-full"
//                   >
//                     <div className="flex items-center">
//                       <AiOutlineAppstore size={23} className="min-w-max" />
//                       <span className="ml-6">Home</span>
//                     </div>
//                     <div className="flex items-center flex-row-reverse">
//                       <IoIosArrowForward size={18} />
//                     </div>
//                   </NavLink>
//                 </li>
//                 {(open || isTabletMid) && (
//                   <div className="py-3 border-slate-300">
//                     {subMenusList?.map((menu) => (
//                       <div key={menu.name} className="flex flex-col gap-2">
//                         <SubMenu
//                           data={menu}
//                           onClick={() => handleSubMenuClick(menu.name)}
//                           isSelected={selectedSubMenu === menu.name}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 <li className="flex items-center mb-3">
//                   <div
//                     className={`link flex items-center justify-between w-full ${
//                       isRetrieveTransactionDisabled
//                         ? "pointer-events-none opacity-50"
//                         : ""
//                     }`}
//                     onClick={handleRetrieveTransactionClick}
//                   >
//                     <div className="flex items-center">
//                       <GrTransaction size={23} className="min-w-max" />
//                       <span className="ml-6">Retrieve Transaction</span>
//                     </div>
//                   </div>
//                 </li>
//                 <li className="flex items-center mb-3">
//                   <NavLink
//                     to={"/vendor-master"}
//                     className="link flex items-center justify-between w-full"
//                   >
//                     <div className="flex items-center">
//                       <FaUsers size={23} className="min-w-max" />
//                       <span className="ml-6">Vendor Master</span>
//                     </div>
//                     <div className="flex items-center flex-row-reverse">
//                       <IoIosArrowForward size={18} />
//                     </div>
//                   </NavLink>
//                 </li>
//                 <li className="flex items-center mb-2">
//                   <NavLink
//                     to={"/audit-log"}
//                     className="link flex items-center justify-between w-full"
//                   >
//                     <div className="flex items-center">
//                       <AiOutlineAudit size={23} className="min-w-max" />
//                       <span className="ml-6">Audit Log</span>
//                     </div>
//                     <div className="flex items-center flex-row-reverse">
//                       <IoIosArrowForward size={18} />
//                     </div>
//                   </NavLink>
//                 </li>
//                 <div>
//                   <hr className="mt-10" />
//                   <div className="flex border-slate-300 p-4 items-center justify-center">
//                     <Link to="/settings">
//                       <GrUserSettings
//                         className={
//                           "min-w-max text-white" +
//                           (open === true ? " w-9 h-9" : " w-7 h-7")
//                         }
//                       />
//                     </Link>
//                   </div>
//                   <div className="flex border-slate-300 p-4 items-center justify-center">
//                     <FaRegQuestionCircle
//                       className={
//                         "min-w-max text-white" +
//                         (open === true ? " w-9 h-9" : " w-7 h-7")
//                       }
//                     />
//                   </div>
//                 </div>
//               </ul>
//             </div>
//           </motion.div>
//           <div className="m-3 md:hidden" onClick={() => setOpen(true)}>
//             <MdMenu size={25} className="bg-dark-blue rounded-s-sm" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
